<div class="sir-anchor" #scrollTarget></div>
<div class="sir-wrapper-outer" [class.sir-is-stuck]="isStuck$ | async">
    <div class="sir-wrapper-inner">
        <sirius-container #tabs>
            <ul role="tablist">
                @for (tab of tabComponents; track $index) {
                    <li [class.sir-active]="$index === currentIndex">
                        <button
                            type="button"
                            role="tab"
                            class="sir-text-style-paragraph-l-bold"
                            [id]="groupId + '-tab-' + $index"
                            [attr.aria-selected]="$index === currentIndex"
                            [attr.aria-controls]="groupId + '-panel-' + $index"
                            [tabindex]="$index === currentIndex ? 0 : -1"
                            (click)="onClick($event, $index)"
                            (keydown)="onKeydown($event)"
                        >
                            {{ tab.title }}
                        </button>
                        <div class="sir-selection-indicator"></div>
                    </li>
                }
            </ul>
        </sirius-container>
    </div>
</div>
<div class="sir-content">
    @if (topSpacer) {
        <sirius-spacer></sirius-spacer>
    }
    <ng-content></ng-content>
</div>
